import styler from 'stylefire'
import { animate } from 'popmotion'
import { debounce } from 'helpers/tools'

const DEFAULTS = {
  allowMultipleOpen: false,
  open: [],
}

export default (items) => {
  // collect wrapper infos
  const wrappers = [
    ...document.querySelectorAll('[data-accordion-wrap]'),
  ].reduce((sum, curr, index) => {
    return {
      ...sum,
      [index]: {
        elem: curr,
        children: [],
      },
    }
  }, {})

  items.forEach((accordion) => {
    if (accordion._hasAccordion) return
    accordion._hasAccordion = true

    let parentIndex
    let transition
    let index = 0
    const parent = accordion.closest('[data-accordion-wrap]')
    const content = accordion.querySelector('[data-accordion-content]')
    const styledContent = styler(content)
    const settings = {
      ...DEFAULTS,
      ...(parent ? JSON.parse(parent.dataset.accordionWrap) : {}),
    }
    const state = {
      open: true,
      styledContent,
      height: styledContent.get('height'),
    }

    if (parent) {
      for (const key in Object.keys(wrappers)) {
        if (wrappers[key].elem === parent) {
          parentIndex = key
          wrappers[key].children = [
            ...wrappers[key].children,
            { accordion, state },
          ]
          break
        }
      }
      for (const element of parent.querySelectorAll('[data-accordion]')) {
        if (element === accordion) break
        else index++
      }
    }

    if (!settings.open.includes(index + 1) && accordion.dataset.accordion !== 'true') {
      transition = toggleAccordion(state, undefined, () => {
        transition = null
        const indicator = accordion.querySelector('[data-accordion-indicator]')
        if (indicator) {
          indicator.classList.toggle(
            indicator.dataset.accordionIndicator,
            !state.open
          )
        }
      })
    }

    // update height on reflow
    window.addEventListener(
      'resize',
      debounce(() => {
        let contentHidden = !state.open
        if (contentHidden)
          toggleAccordion(state, 0, () => {
            state.height = styledContent.get('height')
            toggleAccordion(state, 0)
          })
        else {
          state.height = styledContent.get('height')
        }
      })
    )
    accordion.addEventListener('click', (e) => {
      const { target } = e
      if (target.closest('[data-accordion-toggle]')) {
        // prevent multiple actions
        if (transition) return
        transition = toggleAccordion(state, undefined, () => {
          toggleIndicator(accordion, state)
          transition = null
        })
        if (parentIndex || parentIndex === 0) {
          // close all other accordions
          if (!settings.allowMultipleOpen) {
            wrappers[parentIndex].children.map(({ accordion, state }, i) => {
              if (i !== index && state.open) {
                toggleAccordion(state, undefined, () => {
                  toggleIndicator(accordion, state)
                })
              }
            })
          }
        }
      }
    })
  })
}

const toggleIndicator = (accordion, state) => {
  const indicator = accordion.querySelector('[data-accordion-indicator]')
  if (indicator) {
    indicator.classList.toggle(
      indicator.dataset.accordionIndicator,
      !state.open
    )
  }
}

const toggleAccordion = (state, duration = 300, cb) => {
  return animate({
    ...(state.open
      ? {
          from: { height: state.height },
          to: { height: 0 },
        }
      : {
          from: { height: 0 },
          to: { height: state.height },
        }),
    duration,
    onUpdate: state.styledContent.set,
    onComplete: () => {
      state.open = !state.open
      if (cb) cb()
    },
  })
}